import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/Domain/components/Shared/Accordion/Accordion';

const FAQ_KEYS = [
  'ai_credits',
  'run_out',
  'ai_models',
  'user_licenses',
  'kb_articles',
  'billing',
  'free_trial',
  'change_plan',
  'enterprise',
  'resolution',
] as const;

type Props = {
  openValue: string;
  onOpenChange: (value: string) => void;
};

export const PricingFaq = ({ openValue, onOpenChange }: Props) => {
  const { t } = useTranslation('subscription_page');

  return (
    <section className="mx-auto mb-32 w-full max-w-3xl">
      <h2 className="mb-4 text-center text-xl font-semibold text-foreground">
        {t('pricing.faq.title')}
      </h2>
      <Accordion type="single" collapsible value={openValue} onValueChange={onOpenChange}>
        {FAQ_KEYS.map((key) => (
          <AccordionItem
            key={key}
            value={key}
            id={`faq-${key}`}
            data-testid={`faq-item-${key}`}
            className="scroll-mt-24 last:border-b-0"
          >
            <AccordionTrigger className="cursor-pointer text-left text-base font-medium">
              {t(`pricing.faq.items.${key}.question`)}
            </AccordionTrigger>
            <AccordionContent>
              <div
                className="text-sm leading-relaxed text-muted-foreground [&_a]:font-medium [&_a]:text-foreground [&_a]:underline [&_p]:mt-3 [&_p:first-child]:mt-0 [&_strong]:font-semibold [&_strong]:text-foreground [&_ul]:my-3 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-5"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: t(`pricing.faq.items.${key}.answer`) }}
              />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
